import { render } from "./WidgetLayout.vue?vue&type=template&id=9c641b1c&ts=true"
import script from "./WidgetLayout.vue?vue&type=script&lang=ts"
export * from "./WidgetLayout.vue?vue&type=script&lang=ts"

import "./WidgetLayout.vue?vue&type=style&index=0&id=9c641b1c&lang=scss"

import exportComponent from "/Users/colin/Documents/FUSE/code/live/fusestudio.net/Graphite/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__